import * as React from "react";

import { IText } from "../../../classes/text";

export interface IMonthDayNamesRows {
  firstDayOfWeek: string;
  text: IText;
}
export const MonthDayNamesRowTableHeader = (props: IMonthDayNamesRows) => {

  return (
    <thead className="offScreen">
      <tr>
        {props.firstDayOfWeek.toUpperCase() === "SUNDAY" &&
          <td>{props.text.days.sunday}</td>
        }
        <td>{props.text.days.monday}</td>
        <td>{props.text.days.tuesday}</td>
        <td>{props.text.days.wednesday}</td>
        <td>{props.text.days.thursday}</td>
        <td>{props.text.days.friday}</td>
        <td>{props.text.days.saturday}</td>
        {props.firstDayOfWeek.toUpperCase() !== "SUNDAY" &&
          <td>{props.text.days.sunday}</td>
        }
      </tr>
    </thead>
  );
};
